package app.footyguide.web.page

import app.footyguide.domain.model.Game
import app.footyguide.domain.model.isLive
import kotlinx.datetime.LocalDate

fun shouldEnableAgendaLiveRefresh(
    selectedDate: LocalDate,
    today: LocalDate,
    games: List<Game>,
): Boolean = selectedDate == today && games.any { it.isLive }

fun shouldEnableDetailLiveRefresh(
    game: Game?,
    today: String,
): Boolean {
    val current = game ?: return false
    return current.date == today && current.isLive
}
